(function () {
  'use strict';

  if (window.NotesOSFreebieGrid) {
    window.NotesOSFreebieGrid.initAll(document);
    return;
  }

  function setActiveFilter(buttons, activeButton) {
    var container = activeButton.closest('.notesos-freebie-filters');
    var activeStyle = container ? container.dataset.activeStyle : 'button';
    var inactiveStyle = container ? container.dataset.inactiveStyle : 'button-secondary';

    buttons.forEach(function (button) {
      var isActive = button === activeButton;
      button.classList.remove('button', 'button-secondary');
      button.classList.add(isActive ? activeStyle : inactiveStyle);
      button.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
  }

  function initRoot(root) {
    if (!root || root.dataset.notesosFreebieInitialized === 'true') return;

    var cards = Array.prototype.slice.call(
      root.querySelectorAll('[data-notesos-freebie-card]')
    );
    var filters = Array.prototype.slice.call(
      root.querySelectorAll('[data-notesos-freebie-filter]')
    );

    if (!cards.length) return;

    root.dataset.notesosFreebieInitialized = 'true';

    var records = cards.map(function (card) {
      return {
        card: card,
        item: card.closest('li.grid__item') || card,
        category: card.dataset.category || 'others'
      };
    });
    var perPage = Math.max(1, parseInt(root.dataset.itemsPerPage, 10) || 16);
    var activeCategory = 'all';
    var currentPage = 1;
    var gridGroup = records[0].item.closest('[data-testid="group-block"]');
    var pagination = document.createElement('nav');

    pagination.className = 'notesos-freebie-pagination pagination';
    pagination.dataset.notesosFreebiePagination = '';
    pagination.setAttribute('role', 'navigation');
    pagination.setAttribute('aria-label', 'Freebie pagination');
    pagination.hidden = true;

    if (gridGroup) {
      gridGroup.insertAdjacentElement('afterend', pagination);
    } else {
      root.appendChild(pagination);
    }

    filters.forEach(function (filter) {
      var category = filter.dataset.notesosFreebieFilter;
      if (category !== 'all') {
        filter.hidden = !records.some(function (record) {
          return record.category === category;
        });
      }
    });

    function filteredRecords() {
      if (activeCategory === 'all') return records;
      return records.filter(function (record) {
        return record.category === activeCategory;
      });
    }

    function makePageItem(label, ariaLabel, active, arrowDirection, onClick) {
      var item = document.createElement('li');
      var button = document.createElement('button');
      var baseClass = 'pagination__item inline-flex items-center justify-center relative w-full p-0 decoration-none color-foreground border-style';

      button.type = 'button';
      button.className = baseClass;
      button.setAttribute('aria-label', ariaLabel);

      if (active) {
        button.classList.add('pagination__item--current', 'light');
        button.setAttribute('aria-current', 'page');
        button.disabled = true;
      }

      if (arrowDirection) {
        var hiddenLabel = document.createElement('span');
        var icon = document.createElement('span');
        var iconTemplate = root.querySelector('[data-notesos-pagination-icon]');

        button.classList.add('pagination__item--' + arrowDirection, 'pagination__item-arrow', 'link', 'motion-reduce');
        hiddenLabel.className = 'visually-hidden';
        hiddenLabel.textContent = label;
        icon.className = 'svg-wrapper';
        if (iconTemplate) icon.innerHTML = iconTemplate.innerHTML;
        else icon.textContent = arrowDirection === 'prev' ? '‹' : '›';
        button.appendChild(hiddenLabel);
        button.appendChild(icon);
      } else {
        button.textContent = label;
      }

      button.addEventListener('click', onClick);
      item.appendChild(button);
      return item;
    }

    function scrollToGrid() {
      var target = root.querySelector('.notesos-freebie-filters') || gridGroup;
      if (!target) return;
      target.scrollIntoView({
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
        block: 'start'
      });
    }

    function renderPagination(totalPages) {
      pagination.replaceChildren();
      pagination.hidden = totalPages <= 1;
      if (totalPages <= 1) return;

      var list = document.createElement('ul');
      list.className = 'pagination__list list-unstyled flex flex-wrap';
      list.setAttribute('role', 'list');

      if (currentPage > 1) {
        list.appendChild(
          makePageItem('Previous page', 'Previous page', false, 'prev', function () {
            currentPage -= 1;
            render();
            scrollToGrid();
          })
        );
      }

      for (var page = 1; page <= totalPages; page += 1) {
        (function (pageNumber) {
          list.appendChild(
            makePageItem(
              String(pageNumber),
              'Page ' + pageNumber,
              pageNumber === currentPage,
              '',
              function () {
                if (currentPage === pageNumber) return;
                currentPage = pageNumber;
                render();
                scrollToGrid();
              }
            )
          );
        })(page);
      }

      if (currentPage < totalPages) {
        list.appendChild(
          makePageItem('Next page', 'Next page', false, 'next', function () {
            currentPage += 1;
            render();
            scrollToGrid();
          })
        );
      }

      pagination.appendChild(list);
    }

    function render() {
      var filtered = filteredRecords();
      var totalPages = Math.max(1, Math.ceil(filtered.length / perPage));
      var start;
      var visible;

      currentPage = Math.min(currentPage, totalPages);
      start = (currentPage - 1) * perPage;
      visible = filtered.slice(start, start + perPage);

      records.forEach(function (record) {
        record.item.hidden = visible.indexOf(record) === -1;
      });

      renderPagination(totalPages);
    }

    filters.forEach(function (filter) {
      filter.addEventListener('click', function () {
        activeCategory = filter.dataset.notesosFreebieFilter || 'all';
        currentPage = 1;
        setActiveFilter(filters, filter);
        render();
      });
    });

    root.addEventListener('click', async function (event) {
      var link = event.target.closest('[data-notesos-freebie-download][href]');
      var eventData;

      if (!link || !root.contains(link)) return;

      var originalUrl = link.getAttribute('href') || '';

      eventData = {
        freebie_name:
          link.dataset.downloadName && link.dataset.downloadName !== 'Freebie'
            ? link.dataset.downloadName
            : decodeURIComponent(
                originalUrl.split('/').pop().split('?')[0]
              )
                .replace(/(\.(zip|pdf))+$/gi, '')
                .replace(/[_-]+/g, ' ')
                .trim() || 'Freebie',
        freebie_category: link.dataset.downloadCategory || 'others',
        download_url: originalUrl,
        page_location: window.location.href
      };

      if (
        window.Shopify &&
        window.Shopify.analytics &&
        typeof window.Shopify.analytics.publish === 'function'
      ) {
        window.Shopify.analytics.publish('freebie_download', eventData);
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'freebie_download', eventData);
      } else {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(
          Object.assign({ event: 'freebie_download' }, eventData)
        );
      }

      if (!/\.pdf(?:\?|$)/i.test(originalUrl)) return;

      event.preventDefault();

      try {
        var parsedUrl = new URL(originalUrl, window.location.origin);
        var downloadUrl = originalUrl;

        if (parsedUrl.hostname === 'cdn.shopify.com') {
          var marker = '/files/';
          var markerIndex = parsedUrl.pathname.lastIndexOf(marker);

          if (markerIndex !== -1) {
            var filePath = parsedUrl.pathname.substring(
              markerIndex + marker.length
            );

            downloadUrl =
              window.location.origin +
              '/cdn/shop/files/' +
              filePath +
              parsedUrl.search;
          }
        }

        var response = await fetch(downloadUrl);

        if (!response.ok) {
          throw new Error('Download failed: ' + response.status);
        }

        var blob = await response.blob();
        var blobUrl = URL.createObjectURL(blob);

        var fileName = decodeURIComponent(
          parsedUrl.pathname.split('/').pop() || 'NotesOS-Freebie.pdf'
        );

        var tempLink = document.createElement('a');
        tempLink.href = blobUrl;
        tempLink.download = fileName;
        tempLink.style.display = 'none';

        document.body.appendChild(tempLink);
        tempLink.click();
        tempLink.remove();

        setTimeout(function () {
          URL.revokeObjectURL(blobUrl);
        }, 2000);
      } catch (error) {
        console.error('NotesOS PDF download error:', error);
        window.location.href = originalUrl;
      }
    });

    render();
  }

  function initAll(scope) {
    var roots = [];

    if (scope.matches && scope.matches('[data-notesos-freebie-grid]')) roots.push(scope);
    roots = roots.concat(
      Array.prototype.slice.call(scope.querySelectorAll('[data-notesos-freebie-grid]'))
    );
    roots.forEach(initRoot);
  }

  window.NotesOSFreebieGrid = { initAll: initAll };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();